/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import logger from '@utils/logger';
import Cookies from 'js-cookie';

import { StoragePrefix, StorageTokens } from '@/lib/constants';

/**
 * Add a storage prefix to the key if it exists
 */
function formatKey(key) {
  if (StoragePrefix) {
    return `${StoragePrefix}.${key}`;
  }
  return key;
}

/**
 * Read a value from cookies
 */
function readFromCookies<T>(key: StorageTokens): T | undefined {
  const value = Cookies.get(formatKey(key));

  if (!value) {
    return undefined;
  }

  try {
    return JSON.parse(value);
  } catch (e) {
    logger.warn(e, `Could not parse value for key ${key}`);
    return undefined;
  }
}

/**
 * Write a value to cookies
 */
function writeToCookies(key: StorageTokens, value: unknown, opts?: Cookies.CookieAttributes): void {
  Cookies.set(formatKey(key), JSON.stringify(value), {
    secure: true,
    sameSite: 'None',
    ...(process.env.NODE_ENV === 'development' && {
      secure: false,
      sameSite: 'Lax',
    }),
    ...opts,
  });
}

/**
 * Clear a value from cookies
 */
function clearFromCookies(keys: StorageTokens[] = []): void {
  keys.forEach((key) => Cookies.remove(formatKey(key)));
}

export { readFromCookies, writeToCookies, clearFromCookies };
